const toMongoFilter = require('./src/toMongoFilter.js');
const optimizeMongoPipeline = require('./src/optimizeMongoPipeline.js');
const evalExpr = require('./src/evalExpr.js');
const autoConvert = require('./src/autoConvert.js');

module.exports = {
    toMongoFilter,
    optimizeMongoPipeline,
    evalExpr,
    autoConvert
};